/** 小桔融贷 **/
// import OrangeLoanList from '../../views/orange-loan/loan/loan-list.vue'
import orangeLoanHome from '../../views/orange-loan/loan/loan-home.vue';
import orangeLoanCredit from '../../views/orange-loan/loan/loan-credit.vue';
import orangeLoanCreditApply from '../../components/orange-loan/loan/credit-apply.vue';
import orangeLoanCreditStatus from '../../components/orange-loan/loan/credit-result.vue';
import orangeLoanBorrow from '../../views/orange-loan/loan/loan-borrow.vue';
import orangeLoanApply from '../../components/orange-loan/loan/loan-apply.vue';
import orangeLoanOrderList from '../../components/orange-loan/loan/loan-list.vue';
import orangeLoanApplyStatus from '../../components/orange-loan/loan/loan-apply-status.vue';
import orangeRepayment from '../../views/orange-loan/repayment/repayment.vue';
var orangeLoan = [
    {
        name: 'orangeLoanHome',
        path: 'loan-home',
        component: orangeLoanHome,
    },
    {
        name: 'orangeLoanCredit',
        path: 'credit',
        component: orangeLoanCredit,
        children: [
            {
                name: 'orangeLoanCreditApply',
                path: 'credit-apply',
                component: orangeLoanCreditApply,
            },
            {
                name: 'orangeLoanCreditStatus',
                path: 'credit-result',
                component: orangeLoanCreditStatus,
            },
        ],
    },
    {
        name: 'orangeLoanBorrow',
        path: 'borrow',
        component: orangeLoanBorrow,
        children: [
            {
                name: 'orangeLoanApply',
                path: 'apply',
                component: orangeLoanApply,
            },
            {
                name: 'orangeLoanOrderList',
                path: 'list',
                component: orangeLoanOrderList,
            },
            {
                name: 'orangeLoanApplyStatus',
                path: 'borrow-status',
                component: orangeLoanApplyStatus,
            },
        ],
    },
    {
        name: 'orangeRepayment',
        path: 'repayment',
        component: orangeRepayment,
    },
];
export default orangeLoan;
